import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Navigate, NavLink, Outlet } from 'react-router-dom';
import axios from 'axios';

import ButtonRegular from './ui/ButtonRegular';
import '../styles/AdminControlPanel.css';

const AdminControlPanel = () => {
    const { logout } = useContext(AuthContext);
    const [userDetails, setUserDetails] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserDetails = async () => {
            const token = localStorage.getItem('authToken');
            if (!token) {
                navigate('/login');
                return;
            }
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/users/user`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setUserDetails(response.data);
            } catch (error) {
                console.error('Błąd autoryzacji w panelu admina', error);
                logout();
                navigate('/login');
            }
        };
        fetchUserDetails();
    }, [logout, navigate]);

    const handleLogout = () => {
        logout();
        navigate('/login'); // Zastąpiono window.location.href bezpieczniejszym navigate
    };

    if (!userDetails) return <p>Weryfikacja uprawnień...</p>;

    if (userDetails.role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="admin-panel">
            {/* Sidebar z menu */}
            <nav className="sidebar">
                <h2>Panel Administratora</h2>
                <ul>
                        {/* 'end' sprawia, że klasa active jest dodawana tylko dla dokładnego adresu /admin */}
                    <NavLink to="/admin" end className={({ isActive }) => isActive ? 'active' : ''}>
                        <li>
                            📦 Zarządzanie produktami
                        </li>
                    </NavLink>
                    <NavLink to="/admin/forms" className={({ isActive }) => isActive ? 'active' : ''}>
                        <li>
                            📄 Formularze
                    </li>
                    </NavLink>
                    <NavLink to="/admin/orders" className={({ isActive }) => isActive ? 'active' : ''}>
                        <li>
                            🧾 Zamówienia
                        </li>
                    </NavLink>
                    <NavLink to="/admin/users" className={({ isActive }) => isActive ? 'active' : ''}>
                        <li>
                            👥 Zarządzanie użytkownikami
                        </li>
                    </NavLink>
                    <NavLink to="/admin/settings" className={({ isActive }) => isActive ? 'active' : ''}>
                        <li>
                            ⚙️ Zarządzanie kategoriami i kolorami
                        </li>
                    </NavLink>
                </ul>
                <ButtonRegular onClick={handleLogout}>Wyloguj się</ButtonRegular>
            </nav>

            <main className="admin-content">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminControlPanel;